<template>
  <component :is="isAuthRoute ? 'router-view' : DefaultLayout" />
  <AgentChatSidebar v-if="!isAuthRoute" />
</template>

<script setup>
import { useRoute } from 'vue-router'
import { computed } from 'vue'
import DefaultLayout from './layouts/DefaultLayout.vue'
import AgentChatSidebar from './components/AgentChatSidebar.vue'

const route = useRoute()
const isAuthRoute = computed(() =>
  ['/login', '/register', '/reset-password'].includes(route.path)
)
</script>